import AsanaLogo from '@centered/components/dist/icons/AsanaLogo'
import DiscordLogo from '@centered/components/dist/icons/DiscordLogo'
import GoogleCalendarLogo from '@centered/components/dist/icons/GoogleCalendarLogo'
import LinearLogo from '@centered/components/dist/icons/LinearLogo'
import SlackLogo from '@centered/components/dist/icons/SlackLogo'
import SpotifyLogo from '@centered/components/dist/icons/SpotifyLogo'
import TodoistLogo from '@centered/components/dist/icons/TodoistLogo'
import TryCenteredButton from '../shared/TryCenteredButton'
import Wrapper from '../shared/Wrapper'

export default function AvailableIntegrations(): JSX.Element {
  return (
    <Wrapper className="py-6 mb-20">
      <div className="mb-14">
        <h1 className="text-3xl font-medium text-center mb-10">
          Integrates with Your Favorite Apps.
        </h1>

        <div className="flex gap-6 justify-center mb-10 text-4xl md:text-5xl">
          <SpotifyLogo />
          <GoogleCalendarLogo />
          <SlackLogo />
          <TodoistLogo />
          <LinearLogo />
          <DiscordLogo />
          <AsanaLogo />
        </div>
      </div>

      <div className="flex justify-center">
        <TryCenteredButton />
      </div>
    </Wrapper>
  )
}
